module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "u-pad-l-md"
  }, [(_vm.logo && _vm.logo !== '') ? _c('img', {
    attrs: {
      "src": _vm.logo,
      "width": "156",
      "height": "42",
      "alt": "Gfinity Logotype"
    }
  }) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "u-marg-t-xs t-h1 u-uppercase"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52149de9"}!./src/scripts/components/app-title/template.html
// module id = 918
// module chunks = 0